import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";

const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad({});

    Common.events();
    Common.popup();
  },

  events() {
    $(".scroll-to").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("target");

      let offset;

      if ("top" == target) {
        offset = 0;
      } else {
        offset = $(target).offset().top - 200;
      }
      $("html,body").animate({
        scrollTop: offset,
      });
    });

    $(".scroll-down").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("target");

      let offset = $("#" + target).offset().top;

      $("html,body").animate(
        {
          scrollTop: offset,
        },
        500
      );
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Share
    $(".share__toggle").on("click", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("open");
    });

    $(".share__list-link").on("click", function (e) {
      e.preventDefault();
      const url = $(this).attr("href");
      window.open(url, "Share", "width=600,height=400");
    });
  },

  /**
   * Popup
   */
  popup() {
    const toggleEl = $("[data-popup-target]");

    // Toggle box.
    toggleEl.on("click", (e) => {
      const target = $(e.currentTarget).data("popup-target");
      const targetEl = $(`[data-popup=${target}]`);
      targetEl.toggleClass("open");

      if (target == "search") {
        if (targetEl.hasClass("open")) {
          $("html").addClass("no-scroll");
        } else {
          $("html").removeClass("no-scroll");
        }
      }
    });

    // Close on ESC
    $(document).on("keyup", (e) => {
      const popupEL = $("[data-popup]:is(.open)");
      if (e.keyCode === 27 && popupEL.length) {
        popupEL.removeClass("open");
      }
    });

    // Close on click outside.
    $(document).mouseup(function (e) {
      const popupEL = $("[data-popup]:is(.open)");
      const wrapperEl = popupEL.parent();

      if (
        !wrapperEl.is(e.target) &&
        wrapperEl.has(e.target).length === 0 &&
        popupEL.length
      ) {
        popupEL.removeClass("open");
      }
    });
  },
};

export default Common;
